import { Component } from './cart-discount-component.js';

class DisclosureCustom extends Component {
  requiredRefs = ['disclosureTrigger', 'disclosureContent'];

  connectedCallback() {
    super.connectedCallback();
    this.syncDisclosureState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  toggleDisclosure = () => {
    const { disclosureTrigger: trigger, disclosureContent: content } = this.refs;
    if (!trigger || !content) return;
    
    const expanded = trigger.matches('[aria-expanded="true"]');
    trigger.setAttribute('aria-expanded', String(!expanded));
    trigger.setAttribute(
      'aria-label',
      `${expanded ? trigger.dataset.disclosureOpen : trigger.dataset.disclosureClose}`
    );
    content.inert = expanded;
  };

  syncDisclosureState = () => {
    const { disclosureTrigger: trigger, disclosureContent: content } = this.refs;
    if (!trigger || !content) return;

    const expanded = trigger.matches('[aria-expanded="true"]');
    content.inert = !expanded;
  };

  removeDiscountFromDisclosure = (event) => {
    if (!event || !event.target) return;

    event.preventDefault();
    event.stopPropagation();

    const button = event.target.closest('.disclosure-trigger__pill-remove');
    if (!button) return;

    const pill = button.closest('.disclosure-trigger__pill');
    if (!pill) return;

    const code = pill.getAttribute('data-discount-code');
    if (!code) return;

    const component = document.querySelector('cart-discount-component');
    if (component && typeof component.removeDiscountByCode === 'function') {
      component.removeDiscountByCode(code);
    }
  };
}

if (!customElements.get('disclosure-custom')) {
  customElements.define('disclosure-custom', DisclosureCustom);
}
